import { useNavigate } from 'react-router-dom';
import SiteHeader from './SiteHeader';
import SiteFooter from './SiteFooter';
import HeroSection from './HeroSection';
import ConnectionSection from './ConnectionSection';

import ShowsCarousel from './ShowsCarousel';
import GalleryCarousel from './GalleryCarousel';
import ValuePropositions from './ValuePropositions';
import TestimonialsCarousel from './TestimonialsCarousel';
import NewsletterSection from './NewsletterSection';

export default function HomePage() {
  const navigate = useNavigate();

  const handleSearch = (location: {
    zip?: string;
    lat?: number;
    lng?: number;
    displayLabel?: string;
  }) => {
    if (location.lat != null && location.lng != null) {
      const params = new URLSearchParams();
      params.set('lat', location.lat.toString());
      params.set('lng', location.lng.toString());
      if (location.displayLabel) params.set('q', location.displayLabel);
      if (location.zip) params.set('zip', location.zip);
      navigate(`/events?${params.toString()}`);
    } else if (location.zip) {
      navigate(`/events?zip=${location.zip}`);
    }
  };

  return (
    <div className="min-h-screen bg-warm-50">
      <SiteHeader />
      <main>
        <HeroSection onSearch={handleSearch} />
        <ConnectionSection />
        <ShowsCarousel />
        <GalleryCarousel />
        <ValuePropositions />
        <TestimonialsCarousel />
        <NewsletterSection />
      </main>
      <SiteFooter />
    </div>
  );
}
